import { FC, SVGAttributes } from 'react';

import type { ColorPalette, IconType } from '../../types';
import { findColor } from '../../utils';

import ICON_DICTIONARY from './Icon.const';

export interface IconProps extends SVGAttributes<SVGElement> {
  type: IconType;
  size?: number;
  color?: ColorPalette;
}

const Icon: FC<React.PropsWithChildren<React.PropsWithChildren<IconProps>>> = ({ type, size, color = 'current', width, height, ...props }) => {
  const ReturnIcon = ICON_DICTIONARY[type];
  const selectColor = findColor(color);

  return <ReturnIcon width={width || size} height={height || size} color={selectColor} {...props} />;
};

export default Icon;
